/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const AuthRequestR = t.interface({
  authCode: t.string,

  state: t.string
});

// optional attributes
const AuthRequestO = t.partial({});

export const AuthRequest = t.intersection(
  [AuthRequestR, AuthRequestO],
  "AuthRequest"
);

export type AuthRequest = t.TypeOf<typeof AuthRequest>;
